<template>
  <Layout>
    <div slot="content">
      <div class="table-responsive card p-6"><!-- 단건 조회 -->
        <div>
          <div class="d-flex align-center justify-between">
            <h3>{{ this.custInfo.custName }} ({{ this.custInfo.custAbbr }})</h3>
            <b-button variant="primary" v-text="$t('수정')" @click="modClick"></b-button>
          </div>
          <div>
            <ItemView class="mt-5" :items="[
                {
                    '조직영문명': `${this.custInfo.custFullName || ''}`,
                    '연락처': `${this.custInfo.tel ? this.custInfo.tel.f('tel') : ''}`,
                    '총괄관리자': { slot: 'managerSlot' }, 
                    '조직로고': { slot: 'custLogoSlot' }, 
                },
                {
                  '사업자등록번호': `${this.custInfo.registno ? this.custInfo.registno.f('registno') : ''}`, 
                  'FAX': `${this.custInfo.fax ? this.custInfo.fax.f('tel') : ''}`,
                  '발신자명': `${this.custInfo.defSenderNm || ''}`,
                },
            ]">
              <template slot="managerSlot">
                <span class="gray-txt me-3 single-rp">{{itemManager}}</span>
              </template>
              <template slot="custLogoSlot">
                <b-link v-b-modal.stamp @click="$bvModal.show('custLogoModal')">
                  <img v-if="custInfo.logoFileUrl" :src="$url(custInfo.logoFileUrl)" allowfullscreen
                    class="cust-logo single-rp" style="max-height:64px;" onerror="this.style.display='none'" />
                  <span class="cust-logo single-rp" v-else>로고없음</span>
                </b-link>
              </template>
            </ItemView>
          </div>
        </div>
      </div>

      <!-- 회사 도장 -->
      <TableView :title="$t('회사도장')" @action="goAction" @nextList="nextList" :columns="custStampColumns" min-width="auto"
        :icon-actions="{ 'bi-pencil-fill': '수정', 'bi-trash-fill': '삭제' }" :action-filter="(item) => (item.stampType != '0')"
        :list="stampList" :server-total="total" :minHeight="250">
        <b-button variant="primary" v-b-modal.추가 v-text="$t('회사도장추가')"></b-button>
      </TableView>
    </div>

    <ModalForm @action="updateCust" id="조직수정" :title="$t('조직 수정')" :spec="custColumns" form-only :label-cols="4"
      :data="custInfo" :ok-title="$t('저장')">
      <div slot="custEditLogoSlot" style="padding: 1rem 0; display: flex;">
        <span v-if="this.newLogoFileId" class="ps-3 click-hide">
          <span style="color: green">{{ this.custInfo.logoFileNmOrigin }}</span>
          <span class="ps-3">
            <b-icon icon="x-circle-fill" variant="danger" style="cursor:pointer;"
              @click="delCustLogo()"></b-icon>            
          </span>
        </span>
        <span v-else>-</span>
      </div>
    </ModalForm>

    <ModalForm @action="addCustStamp" id="추가" :title="$t('회사도장 추가')" :spec="custStampColumns" form-only :data="{}" :label-cols="3" />
    <ModalForm @action="modCustStamp" id="수정" :title="$t('회사도장 수정')" :spec="custStampColumns" form-only :data="custStampInfo" :label-cols="3" />
    <ModalForm id="view" :title="$t('회사도장')" :data="custStampInfo" :spec="custStampColumns" ok-only />

    <!-- 이미지 view 모달 -->
    <b-modal lazy id="custLogoModal" size="sm" modal-class="compact text-center" centered hide-footer>
      <img style="max-width:100%" :src="$url(`${this.custInfo.logoFileUrl}`)">
    </b-modal>
  </Layout>
</template>

<script>
import Layout from "@/components/layout/Layout.vue";
import TableView from "@/components/TableView.vue";
import ModalForm from "@/components/ModalForm.vue";
import ItemView from "@/components/ItemView.vue";
const required = true;

export default {
  components: { Layout, TableView, ModalForm, ItemView },
  data: () => ({
    custInfo: {}, itemManager: "", custStampInfo: {}, newLogoFileId: '',
    list: [],
    stampList: [],
    total: 0,
    searchKeyword: '',
    custStampColumns: [   //  회사도장 리스트      
      { key: 'stampType', label: '종류', hide: ['td', 'view'], default: 1, type: 'radio', style: { textAlign: 'center' } },
      { key: 'stampTypeNm', label: '종류', hide: ['추가', '수정'], style: { textAlign: 'center' } },
      { key: 'stampNm', required, label: '도장명', style: { textAlign: 'center' } },
      {
        key: 'stampFile', label: '회사도장', hide: ['view'], required, type: 'stamp', accept: ['.jpg', '.png', '.gif'], style: { textAlign: 'center' }, 
        renderer: (item, s) => {
          const url = s.$url(item.stampFileUrl);
          return `<img data-id="${item.stampFileId}" src="${url}" allowfullscreen style="max-height:64px; cursor:pointer" onerror="this.style.display='none'"/>`
        }
      },
    ],
    custColumns: [    // 조직정보 수정
      { form: 1, label: 'Cust Abbr.', key: 'custAbbr', readonly: ['조직수정'], style: { textAlign: 'center' } },
      { form: 2, label: '조직명', key: 'custName', readonly: ['조직수정'], style: { textAlign: 'center' } },
      { form: 3, label: '조직영문명', key: 'custFullName', readonly: ['조직수정'], style: { textAlign: 'center' } },
      { form: 4, label: '사업자등록번호', key: 'registno', style: { textAlign: 'center' } },
      { form: 5, label: '연락처', key: 'tel', style: { textAlign: 'center' } },
      { form: 6, label: 'FAX', key: 'fax', style: { textAlign: 'center' } },
      { form: 7, label: '발신자명', key: 'defSenderNm', style: { textAlign: 'center' } },
      { form: 8, label: '조직로고', slot: 'custEditLogoSlot', readonly: ['조직수정'] },
      { form: 9, label: '조직로고 파일추가', key: 'logoFile', type: 'file', accept: ['.jpg', '.png', '.gif'] },
    ],
  }),
  created() {
    this.getCustInfo();
    this.getStampList();
    this.custStampColumns.getCol('stampType').options = this.$code('STAMP_TYPE').filter(obj => obj.value == '1');
  },
  mounted() {
    this.$reduceScreen();
  },
  beforeDestroy() { },
  computed: {},
  watch: { searchKeyword() { this.getCustInfo() } },
  methods: {
    async goAction({ action, item, form }) {
      this.custStampInfo = item;
      if (!form && ['수정'].includes(action)) {
        this.$bvModal.show(action) ;
        return;
      }
      else if (!form && ['view'].includes(action)) {
        return;
      }
      else if (['삭제'].includes(action)) {
        const stampSeq = this.custStampInfo.stampSeq;
        const userId = this.custStampInfo.userId;
        if (!form && !(await this.$alert(this.$t('[$] 도장을 삭제 하시겠습니까?', [item.stampNm]), { confirm: true, title: action }))) return;
        const res = await this.$api('main/cust/deleteCustStamp', { form, userId, stampSeq });
        await this.$alert(res.msg);
        this.getCustInfo(); this.getStampList()
        return;
      }
    },
    // 조직정보 수정
    async updateCust({ form }) {
      if (form.get('logoFile')) { // 신규파일 추가 시
        form.append('logoFileId', '');
      } else { // 기존파일 사용 or 삭제 시
        form.append('logoFileId', this.newLogoFileId);
      }

      const res = await this.$api(`main/cust/updateCust`, form);
      await this.$alert(res.msg);
      if (res.success) await this.getCustInfo();
    },
    //조직로고 삭제
    async delCustLogo() {
      this.newLogoFileId = '';
      document.querySelector('.click-hide').style = "opacity:0";
    },
    // 회사도장 추가
    async addCustStamp({ form }) {
      form.append('userId', this.$store.state.user.userId);
      const res = await this.$api('main/cust/insertCustStamp', form);
      await this.$alert(res.msg);
      if (res.success) this.getStampList();
    },
    // 회사도장 수정
    async modCustStamp({ action, form }) {
      if (action == '수정' && !form.get('stampFile')) {
        form.delete('stampFileId')
        form.append('stampFileId', this.custStampInfo.stampFileId);
        const res = await this.$api('main/cust/updateCustStamp', form);
        await this.$alert(res.msg);
        this.getStampList();
      } else {
        form.append('stampSeq', this.custStampInfo.stampSeq);
        form.append('userId', this.custStampInfo.userId);
        const res = await this.$api('main/cust/updateCustStamp', form);
        await this.$alert(res.msg);
        if (res.success) this.getStampList();
      }
    },
    async modClick() {
      this.newLogoFileId = this.custInfo.logoFileId || '';
      return this.$bvModal.show('조직수정');
    },
    nextList() { if (this.total > this.list.length) this.getCustInfo(this.list.length + 1); },
    // 조직 단건조회
    async getCustInfo() {
      const res = await this.$api('main/cust/selectCust', { searchKeyword: this.searchKeyword });
      this.list = this.list.concat(res.data);
      this.custInfo = res.data.cust; 
      this.itemManager = res.data.manager ? res.data.manager.userNm.concat(' (', res.data.manager.userIdText, ')') : '';
    },    
    // 회사도장 리스트 조회
    async getStampList() {
      const res = await this.$api('main/cust/selectCustStampList', { searchKeyword: this.searchKeyword });
      this.stampList = res.list;
      return res;
    },
  },
}
</script>